module.exports = __webpack_public_path__ + "static/media/lunchSpecial.3415a285.pdf";